export default "__VITE_ASSET__59b07108__"